import ScrollFAQ from './views/main.c';
export default ScrollFAQ;
